import React from "react";

interface Props {
  value?: string;
  placeholder: string;
  dataTest: string;
  onChange: any;
}

export default function TextInputCell({ dataTest, ...otherProps }: Props) {
  return (
    <input
      className="text-cell inline-input"
      type="text"
      data-test={dataTest}
      {...otherProps}
    />
  );
}
